export function toUnderscoreCase(object: any) {
  if (object && Object.keys(object).length) {
    return Object.keys(object)
      .map((key) => ({[convertStringToUnderscoreCase(key)]: object[key]}))
      .reduce((prev, next) => ({...prev, ...next}));
  }
  return object;
}

export function convertStringToUnderscoreCase(camelCaseString: string) {
  return camelCaseString
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();
}

export enum ShoppingBagEvent {
  ClickAddToBag = 'click_add_to_bag',
  ClickRemoveFromBag = 'click_remove_from_bag',
  ClickBagIcon = 'click_bag_icon',
  ClickProceedToCheckout = 'click_proceed_to_checkout',
  ClickBuyNow = 'click_buy_now',
}

export interface ProductType {
  productVariantId: string;
  productId?: string;
  productName?: string;
  productPrice: string;
  productQuantity: number;
}

export function getProductsAsJSON(products: ProductType[]) {
  return products.reduce((accum: string[], product: any) => {
    const formattedProduct = toUnderscoreCase(product);
    accum.push(JSON.stringify(formattedProduct));
    return accum;
  }, []);
}

export function getShoppingBagEventPayload(
  eventType: string = ShoppingBagEvent.ClickAddToBag,
  data: {
    currency?: string;
    products?: [ProductType];
    pageId: string;
    totalValue?: number;
    cartId?: string;
  },
) {
  const {currency, products, pageId, totalValue, cartId} = data;
  const shoppingBagProducts = (products && getProductsAsJSON(products)) || [];
  const defaultData = {eventType, pageId};
  switch (eventType) {
    case ShoppingBagEvent.ClickAddToBag: {
      return {
        ...defaultData,
        currency,
        products: shoppingBagProducts,
      };
    }

    case ShoppingBagEvent.ClickRemoveFromBag: {
      return {
        ...defaultData,
        cartId,
        currency,
        products: shoppingBagProducts,
      };
    }

    case ShoppingBagEvent.ClickBagIcon: {
      return defaultData;
    }

    case ShoppingBagEvent.ClickProceedToCheckout: {
      return {
        ...defaultData,
        cartId,
        currency,
        totalValue,
        products: shoppingBagProducts,
      };
    }

    case ShoppingBagEvent.ClickBuyNow: {
      return {
        ...defaultData,
        currency,
        products: shoppingBagProducts,
      };
    }
  }
}
